import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

const OVERLAY_MAX_WIDTH = "640px";

export const useImportProcessingOverlayStyles = makeStyles({
  surface: {
    width: "max-content",
    maxWidth: `min(${OVERLAY_MAX_WIDTH}, 90vw)`,
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[5]}`,
    fontFamily: projectIqTokens.fontFamily,
    borderRadius: designTokens.borderRadius.lg,
  },
  body: {
    display: "block",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  text: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.bold,
    lineHeight: String(designTokens.lineHeight.tight),
    color: projectIqTokens.ink,
  },
  description: {
    margin: 0,
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.ink3,
  },
});
